import { solveChallenge } from 'altcha-lib'
import { deriveKey } from 'altcha-lib/algorithms/web/pbkdf2'
import type { AxiosInstance } from 'axios'

interface AltchaChallenge {
  parameters: {
    algorithm: string
    nonce: string
    salt: string
    cost: number
    keyLength: number
    keyPrefix: string
    expiresAt?: number
  }
  signature?: string
}

export async function getAltchaToken(masterAxiosInstance: AxiosInstance): Promise<string> {
  const { data: challenge } = await masterAxiosInstance.get<AltchaChallenge>('altcha/challenge')

  const solution = await solveChallenge({
    challenge,
    deriveKey,
  })

  if (!solution) {
    throw new Error('ALTCHA: Failed to solve challenge')
  }

  const payload = {
    challenge,
    solution,
  }

  return btoa(JSON.stringify(payload))
}
